import styled from "styled-components";
import { theme } from "@src/theme";

export const SubmitButton = styled.button<{
  submitted?: boolean;
  disabled?: boolean;
}>`
  background-color: ${({ submitted, disabled }) =>
    disabled ? "transparent" : submitted ? theme.colors.yellow : "transparent"};
  color: ${({ submitted, disabled }) =>
    disabled
      ? theme.colors.gray200
      : submitted
        ? theme.colors.black
        : theme.colors.yellow};
  border: ${({ submitted, disabled }) =>
    disabled
      ? `1px solid ${theme.colors.gray200}`
      : submitted
        ? `1px solid ${theme.colors.yellow}`
        : `1px solid ${theme.colors.yellow}`};
  width: 100px;
  height: 30px;
  border-radius: 15px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
`;
